module.exports = __webpack_public_path__ + "img/illustration-flora.82c3d186.png";